module.exports = __webpack_public_path__ + "img/zimb.daf1bee0.jpg";